import styled from 'styled-components';
import { StyledTableCell } from '../TableCell/TableCell.styles';
export var StyledTableHeaderCell = /*#__PURE__*/styled(StyledTableCell).withConfig({
  displayName: "StyledTableHeaderCell",
  componentId: "c11n-8-107-0__sc-187oiue-0"
})([""]);